import { PageHeader } from "../components/PageHeader";

type Crumb = { label: string; to?: string };

export function HubPlaceholder({
  title,
  breadcrumb,
  subtitle,
}: {
  title: string;
  breadcrumb: Crumb[];
  subtitle?: string;
}) {
  return (
    <>
      <PageHeader
        breadcrumb={breadcrumb.map((c) => (c.to ? { label: c.label, to: c.to } : { label: c.label }))}
        title={title}
        subtitle={subtitle ?? "This screen is reserved for your workflow. Connect APIs or forms when ready."}
      />
      <div className="card card--elevated">
        <p className="text-muted">
          No data to show yet. Use this area for registers, approvals, or integrations.
        </p>
      </div>
    </>
  );
}

export function BillsInwardPage() {
  return (
    <HubPlaceholder
      title="Bills — Inward"
      breadcrumb={[
        { label: "Home", to: "/" },
        { label: "Bills", to: "/bills/inward" },
        { label: "Inward" },
      ]}
    />
  );
}

export function BillsOutwardPage() {
  return (
    <HubPlaceholder
      title="Bills — Outward"
      breadcrumb={[
        { label: "Home", to: "/" },
        { label: "Bills", to: "/bills/inward" },
        { label: "Outward" },
      ]}
    />
  );
}
